import { faEye, faEyeSlash, faArrowLeft, faArrowRight } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const PlayerControls = ({ onPrev, onNext, onMarkWatched, onUnmarkWatched, watched }) => {
  return (
    <div className='flex items-center justify-between bg-white rounded-lg shadow px-4 py-3 mt-3'>
      {watched ? (
        <button
          onClick={onUnmarkWatched}
          className='flex items-center gap-2 text-green-600 hover:text-red-1 text-sm font-montserrat font-semibold transition-colors'
        >
          <FontAwesomeIcon icon={faEyeSlash} />
          <span className='hidden sm:inline'>Marcar como no visto</span>
        </button>
      ) : (
        <button
          onClick={onMarkWatched}
          className='flex items-center gap-2 text-gray-500 hover:text-red-1 text-sm font-montserrat font-semibold transition-colors'
        >
          <FontAwesomeIcon icon={faEye} />
          <span className='hidden sm:inline'>Marcar como visto</span>
        </button>
      )}

      <div className='flex items-center gap-3'>
        <button
          onClick={onPrev}
          className='flex items-center gap-2 border border-gray-200 hover:border-red-1 hover:text-red-1 text-gray-600 text-sm font-montserrat font-semibold px-4 py-2 rounded-lg transition-colors'
        >
          <FontAwesomeIcon icon={faArrowLeft} />
          <span>Anterior</span>
        </button>
        <button
          onClick={onNext}
          className='flex items-center gap-2 bg-red-1 hover:bg-darkred text-white text-sm font-montserrat font-semibold px-4 py-2 rounded-lg transition-colors'
        >
          <span>Siguiente</span>
          <FontAwesomeIcon icon={faArrowRight} />
        </button>
      </div>
    </div>
  );
};

export default PlayerControls;
